(function () {
    'use strict';

    angular
            .module('imnApp')
            .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Authenticate'];

    function hasAuthority(Authenticate) {
        var directive = {
            restrict: 'A',
            replace: true,
            link: linkFunc,
            eventHandle: eventHandle,
            eventCommom: eventCommom
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var value = attrs.hasAuthority.trim();
            var isBehavior = false;
            var notPermissionFlag = value[0] === '!';

            if (notPermissionFlag) {
                value = value.slice(1).trim();
            }
            // verify if behavior exists
            if (attrs.hasBehavior) {
                isBehavior = true;
            }

            function toggleVisibilityBasedOnPermission() {
                var hasPermission = false;
                if (value.indexOf('||') != -1) {
                    var authArray = value.split('||');

                    for (var i = 0; i < authArray.length; i++) {
                        hasPermission = Authenticate.hasPermission(authArray[i]);
                        if (hasPermission) {
                            break;
                        }
                    }
                } else {
                    hasPermission = Authenticate.hasPermission(value);
                }

                // Normal flow
                // variable:hasPermission == true and notPermissionFlag == null
                // ex:userList
                // 1-the user must have permission, releasing a ui that requires valid permission
                //
                // Alternative flow
                // variable:notPermissionFlag == true and hasPermission == false
                // ex:!userList
                // 2-if the directive call contains the character "!"
                // ui will be displayed because it is an alternative ui when the user does
                // not have permission but should view a standard ui.

                if (hasPermission && !notPermissionFlag || !hasPermission && notPermissionFlag) {
                    element.show();
                } else {
                    if (isBehavior) {
                        eventHandle(attrs.hasBehavior, element, attrs, scope);
                    } else {
                        element.hide();
                        eventHandle('hide', element);
                    }
                }
            }
            toggleVisibilityBasedOnPermission();
            // can be used in the future for real-time permission
            // listening for changes to load permissions
            // scope.$on('permissionsChanged', toggleVisibilityBasedOnPermission);
        }

        function eventHandle(event, element) {
            // options for the disable event
            switch (event) {
                case 'hide':
                    element.remove();
                    break;
                case 'disable-default':
                    eventCommom(element);
                    element.addClass('auth-disabled disabled-default');
                    break;
                case 'disable-link':
                    eventCommom(element);
                    element.addClass('auth-disabled disabled-link');
                    break;
                case 'disable-button':
                    eventCommom(element);
                    element.addClass('auth-disabled disabled-button');
                    break;
                case 'disable-button-float':
                    eventCommom(element);
                    element.addClass('auth-disabled disabled-button-float');
                    break;
            }
        }

        function eventCommom(element) {
            // removes the method name in the ng-click attribute
            element.attr('ng-click', '');
            // adds disable attribute for element
            element.prop('disabled', true);
            // disables click event for element
            angular.element(element).off('click');
        }
    }
})();
